import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

import ItemBar from '@formstack/phoenix/components/ItemBar/ItemBar';
import ItemBarActions from '@formstack/phoenix/components/ItemBar/ItemBarActions';
import ItemBarDetails from '@formstack/phoenix/components/ItemBar/ItemBarDetails';
import ItemBarHeader from '@formstack/phoenix/components/ItemBar/ItemBarHeader';

import { TransientProps } from '@/common/Types/TransientProps';

import { IAppListItem } from './interface';

const StyledItemBar = styled(ItemBar)<TransientProps<{ disabled: boolean }>>`
  ${({ $disabled }) =>
    $disabled
      ? css`
          opacity: 0.5;
          cursor: not-allowed;
        `
      : ''}
`;

const iconStyle: CSSProperties = {
  width: '46px',
  height: '46px',
};

const AppListItem = ({
  name,
  icon,
  disabled = false,
  isSelected,
  actions,
  details,
}: IAppListItem) => {
  const iconItem = icon ? (
    <img src={icon} alt={name} style={iconStyle} />
  ) : (
    <div style={iconStyle} />
  );
  return (
    <StyledItemBar
      dataTest={name}
      selected={isSelected}
      renderAvatar={() => iconItem}
      $disabled={disabled}
    >
      <ItemBarHeader>{name}</ItemBarHeader>
      {details && <ItemBarDetails>{details}</ItemBarDetails>}
      {actions && <ItemBarActions>{actions}</ItemBarActions>}
    </StyledItemBar>
  );
};

export { AppListItem };
